import React from "react";
import {useTranslation} from "react-i18next";
import comVisionImg from "../../assets/images/vision_header.jpg";
import visionTopImg from "../../assets/images/vision-top-img.png";
import visionContent1 from "../../assets/images/vision-teamwork.png";
import visionContent2 from "../../assets/images/vision-teamwork2.png";
import visionContent3 from "../../assets/images/vision-teamwork3.png";
import dompurify from "dompurify";
import comInfoBackg from "../../assets/images/company-info-bak.jpeg";
import TopBanner from "../../components/TopBanner";

const CompanyVision: React.FC<any> = () => {
    const {t} = useTranslation();
    return (
        <>
            <div className="description">
                <main>
                    <TopBanner image={comVisionImg} title={t('header:btn_company_vision')} altText={t('header:btn_company_vision')}/>
                    {/*<div className="subpage-banner  bg-cover relative text-white font-primary">*/}
                    {/*    <img src={comVisionImg} alt="company vision logo" className="w-full align-middle h-96 object-cover object-center lg:h-auto"/>*/}
                    {/*    <div className="banner-description-v2 container mx-auto absolute right-0 left-0 z-10">*/}
                    {/*        <h2 className="text-3xl md:text-4xl lg:text-6xl xl:text-100 font-bold relative text-secondary">{t('header:btn_company_vision')}</h2>*/}
                    {/*    </div>*/}
                    {/*    <div className="overlay absolute bg-overlay-0"></div>*/}
                    {/*</div>*/}

                    <section className="img-des pt-16 pb-8 xl:pt-32 xl:pb-16">
                        <div className="img-des-container container mx-auto">
                            <div className="img-des-pic mb-8 xl-custom-1366:mb-14">
                                <img src={visionTopImg} alt="com info top image" className="w-full align-middle"/>
                            </div>
                            <div className="img-des-txt text-primary">
                                <h2 className="text-xl lg:text-2xl xl-custom-1280:text-3xl 4xl-custom:text-5xl text-primary font-primary">{t('company:vision.top.title')}</h2>
                                <p className="text-base lg:text-lg mt-4 pl-4 relative lg:pl-8 font-primary">
                                    {/*{t('company:vision.top.content')}*/}
                                    <div className={`description-highlight`}
                                         dangerouslySetInnerHTML={{__html: dompurify.sanitize(t('company:vision.top.content'))}}/>
                                </p>
                            </div>
                        </div>
                    </section>

                    <section className="pb-16 lg:pb-32">
                        <div className="py-8 lg-normal:pb-0 lg:pt-16">
                            <div className="flex flex-col lg:flex-row justify-center our-vision-container container mx-auto ">
                                <div className="lg:w-2/4 w-full mb-8 lg:mb-0 lg:mr-8 xl-custom-1280:mr-16">
                                    <h2 className="text-4xl lg:text-5xl xl:text-6xl font-bold font-secondary text-secondary pb-2 xl:pb-4">
                                        {t('company:vision.content.title1')}
                                    </h2>
                                    <div className="text-base lg:text-lg font-primary text-primary leading-8">
                                        <p className="pb-4 xl:pb-8">
                                            {t('company:vision.content.content1')}
                                        </p>
                                    </div>
                                </div>
                                <div className="lg:w-2/4 w-full">
                                    <img className="w-auto lg:m-0 mx-auto w-full" src={visionContent1} alt="large-group-successful-business-people-standing-together-concept-teamwork"/>
                                </div>
                            </div>

                            {/*<div className="lg-normal:flex hidden justify-center"><img src={""} alt=""/></div>*/}
                        </div>
                        <div className="py-8 lg-normal:pb-0 ">
                            <div className="flex flex-col lg:flex-row justify-center our-vision-container container mx-auto lg:flex-row-reverse">
                                <div className="lg:w-2/4 w-full mb-8 lg:mb-0 lg:ml-8 xl-custom-1280:ml-16">
                                    <h2 className="text-4xl lg:text-5xl xl:text-6xl font-bold font-secondary text-secondary pb-2 xl:pb-4">{t('company:vision.content.title2')}</h2>
                                    <div className="text-base lg:text-lg font-primary text-primary leading-8">
                                        <p className="pb-4 xl:pb-8">
                                            {t('company:vision.content.content2')}
                                        </p>
                                    </div>
                                </div>
                                <div className="lg:w-2/4 w-full">
                                    <img className="w-auto lg:m-0 mx-auto w-full" src={visionContent2} alt="large-group-successful-business-people-standing-together-concept-teamwork"/>
                                </div>
                            </div>

                            {/*<div className="lg-normal:flex hidden justify-center"><img src="./img/ourvision/Path 327.png" alt=""/></div>*/}
                        </div>
                        <div className="py-8 lg-normal:pb-0 ">
                            <div className="flex flex-col lg:flex-row justify-center our-vision-container container mx-auto ">
                                <div className="lg:w-2/4 w-full mb-8 lg:mb-0 lg:mr-8 xl-custom-1280:mr-16">
                                    <h2 className="text-4xl lg:text-5xl xl:text-6xl font-bold font-secondary text-secondary pb-2 xl:pb-4">{t('company:vision.content.title3')}</h2>
                                    <div className="text-base lg:text-lg font-primary text-primary leading-8">
                                        <p className="pb-4 xl:pb-8">
                                            {t('company:vision.content.content3')}
                                        </p>
                                    </div>
                                </div>
                                <div className="lg:w-2/4 w-full">
                                    <img className="w-auto lg:m-0 mx-auto w-full" src={visionContent3} alt="large-group-successful-business-people-standing-together-concept-teamwork"/>
                                </div>
                            </div>
                            {/*<div className="lg-normal:flex hidden justify-center"><img src="" alt=""/></div>*/}
                        </div>
                    </section>
                </main>
            </div>
        </>
    )
}

export default CompanyVision;